"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.MemoryCache = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _keytimeout = require("./keytimeout");
var MemoryCache = exports.MemoryCache = /*#__PURE__*/function () {
  function MemoryCache(options) {
    if (options === void 0) {
      options = {};
    }
    this.ttl = options.ttl;
    this.keyTimeout = new _keytimeout.KeyTimeout();
    this.cache = {};
  }
  var _proto = MemoryCache.prototype;
  _proto.get = function get(key) {
    var cachedValue = this.cache[key];
    if (cachedValue) {
      return cachedValue;
    }
    return undefined;
  };
  _proto.remove = function remove(key) {
    this.keyTimeout.clearTimeout(key);
    delete this.cache[key];
  };
  _proto.set = /*#__PURE__*/function () {
    var _set = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(key, data) {
      var _this = this;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.cache[key] = data;
            if (typeof this.ttl === "number") {
              this.keyTimeout.updateTimeout(key, this.ttl, function () {
                return _this.remove(key);
              });
            }
            return _context.abrupt("return", this.get(key));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function set(_x, _x2) {
      return _set.apply(this, arguments);
    }
    return set;
  }();
  return MemoryCache;
}();